import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignSourceParams from './CampaignSourceParams';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedCampaignSourceParams = connect(
  mapStateToProps, null,
)(CampaignSourceParams);

export default withTranslation(['administration'])(ConnectedCampaignSourceParams as any);
